import { render, staticRenderFns } from "./PlayersPendingAddFollowLink.vue?vue&type=template&id=0f1bac0c&"
import script from "./PlayersPendingAddFollowLink.vue?vue&type=script&lang=js&"
export * from "./PlayersPendingAddFollowLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports